import { isSameSearchCriteria } from "domains/publication/reducer";
import type { RootState } from "types/redux";

export const createInitiativesForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.initiatives.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, { ...getInitiativesSearchCriteria(state), id }),
  );

export const getInitiativesSearchCriteria = (state: RootState) => state.domains.initiatives.searchCriteria;

export const getIsInitiativesFiltered = (state: RootState) => {
  const { search, type } = getInitiativesSearchCriteria(state);
  return !!search || !!type;
};

export const getInitiativesFilterCount = (state: RootState) => {
  const { search, type } = getInitiativesSearchCriteria(state);
  let count = 0;
  if (search) count++;
  if (type) count++;
  return count;
};
